import client from '@/shared/apis/client'
import { CreateTutorialPatientsResponse } from '@/features/internal/tutorial-patient/types/tutorialPatient'

// 動作確認用のチュートリアル患者を自薬局配下に作成する。
// 作成された患者は patient_code の TEST 接頭辞でサーバ側が本番患者一覧から分断する。
export const createTutorialPatients =
  async (): Promise<CreateTutorialPatientsResponse> => {
    const response = await client.post<CreateTutorialPatientsResponse>(
      '/api/patients/tutorial-patients/'
    )
    return response.data
  }
